var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"search-box-dropdown"},[_c('BlockEventDropdown',{attrs:{"withSearch":""}}),_c('BlockSearchBox',{attrs:{"withFilter":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }